import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import Remittance from "./Remittance";
import Document from "./Document";
import Factor from "./Factor";
import Conflicts from "../Conflicts/Conflicts";

export default class Remittances extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'remittance',
            data: null,
            loading: true,
            ids: [],
            inline: this.isNull(props.Inline) ? false : props.Inline,
            filters: {
                filter: 0,
                type: 0,
                io: props.IO,
                personName: '',
                factorNumber: '',
                documentNumber: '',
                orderingId: this.isNull(props.OrderingId) ? null : props.OrderingId,
                currentAnnual: this.isNull(props.CurrentAnnual) ? true : props.CurrentAnnual,
            },
            systemModuleId: 5,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 0,
            currentConflictId: null,
            conflicts: []
        };
        this.setMenuId(this.state.filters.io);
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    setMenuId(io) {
        if (io === 1) this.state.menuId = 47;
        if (io === 2) this.state.menuId = 48;
        if (io === 3) this.state.menuId = 49;
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
                this.getConflicts();
            });
    }
    getConflicts() {
        this.httpPost("api/v1/conflict/list", {
            filters: {
                usage: 2
            }
        })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ conflicts: data.records });
                }
            });
    }
    showConflicts() {
        this.showComponents({ component: <Conflicts Caller={this} Usage={2} /> });
    }
    saveChecked(entityRecordId, checked) {
        if (this.isBlank(this.state.currentConflictId)) return;
        var conflictId = this.state.currentConflictId;

        this.httpPost("api/v1/conflict/check", {
            usage: 2,
            conflictId,
            entityRecordId,
            checked
        }, false)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });

        this.state.data.records.forEach(f => {
            if (f.id === entityRecordId) {
                var tempConflicts = [];
                f.conflicts.forEach(c => {
                    if (c !== conflictId) tempConflicts.push(c);
                });
                if (checked) tempConflicts.push(conflictId);
                f.conflicts = tempConflicts;
            }
        });

        this.setState({ data: this.state.data });
    }
    componentWillReceiveProps(props) {
        if (props.IO == this.state.filters.io) return;
        this.state.filters.io = props.IO;
        this.setMenuId(this.state.filters.io);
        this.refreshData();
    }
    getCaptions() {
        if (this.state.filters.io == 1) return "رسیدها";
        if (this.state.filters.io == 2) return "حواله ها";
        if (this.state.filters.io == 3) return "جابجایی های بین انبار";
    }
    getCaption() {
        if (this.state.filters.io == 1) return "رسید";
        if (this.state.filters.io == 2) return "حواله";
        if (this.state.filters.io == 3) return "جابجایی بین انبار";
    }
    onEdit(record) {
        this.removeKeyDown();
        if (!this.isNull(record.parentId))
            this.showComponents({ component: <Remittance IO={3} Caller={this} Id={record.parentId} /> });
        else
            this.showComponents({ component: <Remittance IO={record.io} Caller={this} Id={record.id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Remittance OrderingId={this.state.filters.orderingId} IO={this.state.filters.io} Caller={this} /> });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    showFactor(id, type) {
        this.removeKeyDown();
        this.showComponents({ component: <Factor Type={type} Caller={this} Id={id} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        {this.state.inline === false && <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست {this.getCaptions()}</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} {this.getCaption()} یافت شد</p>
                            </div>
                        </div>}
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em>
                                                <span>ثبت {this.getCaption()} جدید</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder={"شماره " + this.getCaption()} className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.personName} onChange={e => this.state.filters.personName = e.target.value} placeholder="طرف حساب" className="form-control" />
                                            </div>
                                            {this.state.filters.io !== 3 && <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.factorNumber} onChange={e => this.state.filters.factorNumber = e.target.value} placeholder="شماره فاکتور" className="form-control" />
                                            </div>}
                                            {this.state.filters.io !== 3 && <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.documentNumber} onChange={e => this.state.filters.documentNumber = e.target.value} placeholder="شماره سند" className="form-control" />
                                            </div>}
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.type} onChange={e => this.state.filters.type = parseInt(e.target.value)} type="text" className="form-control">
                                                    <option value="0">همه نوع</option>
                                                    {this.state.filters.io === 1 && <option value="1">خرید</option>}
                                                    {this.state.filters.io === 1 && <option value="4">برگشت از فروش</option>}
                                                    {this.state.filters.io === 1 && <option value="5">موجودی اول دوره</option>}
                                                    {this.state.filters.io === 1 && <option value="7">تولید</option>}
                                                    {this.state.filters.io === 1 && <option value="10">اضافات</option>}
                                                    {this.state.filters.io === 1 && <option value="12">امانی</option>}
                                                    {this.state.filters.io === 1 && <option value="14">خرید خارجی</option>}
                                                    {this.state.filters.io === 1 && <option value="15">خرید ملزومات</option>}
                                                    {this.state.filters.io === 1 && <option value="16">دارایی ثابت</option>}

                                                    {this.state.filters.io === 2 && <option value="2">فروش</option>}
                                                    {this.state.filters.io === 2 && <option value="3">برگشت از خرید</option>}
                                                    {this.state.filters.io === 2 && <option value="6">مصرف</option>}
                                                    {this.state.filters.io === 2 && <option value="11">کسورات</option>}
                                                    {this.state.filters.io === 2 && <option value="13">امانی</option>}

                                                    <option value="8">جابجایی بین انبار</option>
                                                </select>
                                            </div>
                                            {this.state.filters.io !== 3 && <div className="form-wrap">
                                                <select defaultValue={this.state.filters.filter} onChange={e => this.state.filters.filter = parseInt(e.target.value)} type="text" className="form-control">
                                                    <option value="0">فاقد فیلتر</option>
                                                    <option value="1">فاقد فاکتور</option>
                                                    <option value="2">فاقد سند</option>
                                                </select>
                                                <a onClick={e => this.showConflicts() } className="hand">موضوعات</a>
                                            </div>}
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ {this.getCaption()} یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                            {this.state.filters.io !== 3 && <div className="nk-tb-col text-center"><span className="sub-text">سند</span></div>}
                                            {this.state.filters.io !== 3 && <div className="nk-tb-col text-center"><span className="sub-text">فاکتور</span></div>}
                                            {this.state.filters.io !== 3 && <div className="nk-tb-col text-center"><span className="sub-text">انبار</span></div>}
                                            {this.state.filters.io === 3 && <div className="nk-tb-col text-center"><span className="sub-text">انبار مبدا</span></div>}
                                            {this.state.filters.io === 3 && <div className="nk-tb-col text-center"><span className="sub-text">انبار مقصد</span></div>}
                                            {this.state.filters.io !== 3 && <div className="nk-tb-col text-center"><span className="sub-text">شخص</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">شرح</span></div>
                                            {this.state.filters.io !== 3 && <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                            {this.state.filters.currentAnnual === false && <div className="nk-tb-col text-center"><span className="sub-text">سال مالی</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">صدور فاکتور</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مرحله</span></div>
                                            <div className="nk-tb-col text-end" style={{ display: "flex", gap: "5px", padding: "5px" }}>
                                                <select defaultValue={this.state.currentConflictId} onChange={e => this.setState({ currentConflictId: e.target.value })} className="form-control">
                                                    <option value="">انتخاب مغایرت</option>
                                                    {this.state.conflicts.map(con => <option value={con.id}>{con.name}</option>)}
                                                </select>
                                                <a onClick={e => this.showConflicts()} className="hand text-primary"><i className="fa fa-list"></i></a>
                                            </div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item " + (record.conflicts.includes(this.state.currentConflictId) ? "highlighted" : "")} key={record.id + "_" + this.state.currentConflictId}>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record)} title="مشاهده و ویرایش">
                                                            {record.number}
                                                        </a>
                                                    </span>
                                                </div>
                                                {this.state.filters.io !== 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">سند: </span>
                                                    <span className="sub-text text-center">
                                                        {record.documentNumber > 0 && <a className="text-primary txt-bold hand" onClick={e => this.showDocument(record.documentId)}>{record.documentNumber}</a>}
                                                    </span>
                                                </div>}
                                                {this.state.filters.io !== 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">فاکتور: </span>
                                                    <span className="sub-text text-center">
                                                        {record.factorNumber > 0 &&
                                                            <a className="text-primary txt-bold hand" onClick={e => this.showFactor(record.factorId, record.factorType)}>{record.factorNumber}</a>
                                                        }                                               
                                                    </span>
                                                </div>}
                                                {this.state.filters.io !== 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">انبار: </span>
                                                    <span className="sub-text text-center">{record.warehouseName}</span>
                                                </div>}
                                                {this.state.filters.io === 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">انبار مبدا: </span>
                                                    <span className="sub-text text-center">{record.warehouseName}</span>
                                                </div>}
                                                {this.state.filters.io === 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">انبار مقصد: </span>
                                                    <span className="sub-text text-center">{record.warehouseName2}</span>
                                                </div>}
                                                {this.state.filters.io !== 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">شخص: </span>
                                                    <span className="sub-text text-center">{record.personName}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شرح: </span>
                                                    <span className="sub-text text-center">{record.description}</span>
                                                </div>
                                                {this.state.filters.io !== 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">نوع: </span>
                                                    <span className="sub-text text-center">{record.typeString}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ: </span>
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                                {this.state.filters.currentAnnual === false && <div className="nk-tb-col">
                                                    <span className="onlyMobile">سال مالی: </span>
                                                    <span className="sub-text text-center">{record.annualTitle}</span>
                                                </div>}
                                                <div>
                                                    <span className="onlyMobile">صدور فاکتور: </span>
                                                    <span className="sub-text text-center">{record.manualFactor ? "دستی" : "خودکار"}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مرحله: </span>
                                                    <span className="sub-text text-center">{record.workFlowStepName}</span>
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    {!this.isBlank(this.state.currentConflictId) && <input type="checkbox" key={record.id + "_" + this.state.currentConflictId} defaultChecked={record.conflicts.includes(this.state.currentConflictId)} onChange={e => this.saveChecked(record.id, e.target.checked)} />}
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        <li>
                                                                            <a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                                <em className="icon ni ni-cross-fill-c"></em> حذف
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline === false && <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),

            ];
        return contents;
    }
}